module.exports = __webpack_public_path__ + "img/Forgot-mail1-BP.2e68a921.png";